var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-icon"},[_c('v-icon',{attrs:{"size":"24px","color":"darkPink"}},[_vm._v("mdi-delete")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }